export function pushga(data: {
  event?: string;
  eventCategory: string;
  eventAction?: string | number;
  eventLabel?: string | number;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!data.event && data.eventCategory) data.event = data.eventCategory;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}

export function pushEcommerceGAEvent(data: {event?: string; ecommerce?: Object; path?: string}) {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}
